/**
 * 请求缓存池 - 避免重复的并发请求
 * 当同一个请求正在处理时，返回同一个 Promise，而不是发起新的请求
 */

const pendingMap = new Map();

/**
 * 获取或创建请求
 * @param {string} key - 请求的唯一标识
 * @param {Function} requestFn - 返回 Promise 的请求函数
 * @returns {Promise} 请求的 Promise
 */
export function getOrCreateRequest(key, requestFn) {
  // 如果该请求正在进行中，直接返回现有的 Promise
  if (pendingMap.has(key)) {
    return pendingMap.get(key);
  }

  // 创建新的请求 Promise
  const promise = requestFn()
    .finally(() => {
      // 请求完成后（无论成功或失败），从缓存中删除
      pendingMap.delete(key);
    });

  // 将 Promise 存入缓存
  pendingMap.set(key, promise);
  return promise;
}

/**
 * 清除指定 key 的缓存
 * @param {string} key - 请求的唯一标识
 */
export function clearRequestCache(key) {
  pendingMap.delete(key);
}

/**
 * 清除所有缓存
 */
export function clearAllRequestCache() {
  pendingMap.clear();
}

/**
 * 获取当前缓存的数量（用于调试）
 * @returns {number}
 */
export function getCacheSize() {
  return pendingMap.size;
}
